import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useAddVenueToTeam, useListTeamHomeVenues, } from "../api/TeamVenueApiProvider";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { AddVenueToEntity } from "../venues/AddVenueToEntity";
export const AddVenueToTeam = () => {
    const navigate = useNavigate();
    const { id: teamId } = useNumericParams();
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserTeamPermissions({ teamId });
    const { canModify = false } = permissions || {};
    const { data: team, isLoading: teamLoading } = useRetrieveTeam({
        id: teamId,
        enabled: canModify,
    });
    const { data: existingVenues, isLoading: venuesLoading, error: venuesError, } = useListTeamHomeVenues({
        teamId,
        enabled: !!teamId && canModify,
    });
    const addVenueMutation = useAddVenueToTeam({
        teamId,
        onSuccess: () => {
            navigate(`/teams/${teamId}/venues/`);
        },
        onError: () => { },
    });
    const handleAdd = (venueId, fromDate) => {
        if (!teamId)
            return;
        addVenueMutation.mutate({
            team: teamId,
            venue: venueId,
            ...(fromDate && { fromDate }),
        });
    };
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    // Also gate on the home-venues query: it feeds the duplicate-prevention guard,
    // so rendering before it resolves (or after it errors) would offer an
    // already-home venue and allow a duplicate add.
    if (teamLoading || venuesLoading) {
        return _jsx(Loading, {});
    }
    if (!team || !teamId || venuesError) {
        return _jsx(ErrorView, {});
    }
    // Get IDs of active venues to filter from search results
    const existingVenueIds = existingVenues?.filter((v) => v.isActive).map((v) => v.venue.id) || [];
    return (_jsx(AddVenueToEntity, { entityName: "team", entityDisplayName: team.name, entityId: teamId, cancelUrl: `/teams/${teamId}/venues/`, existingVenueIds: existingVenueIds, addMutation: addVenueMutation, onAdd: handleAdd }));
};
